import { Block, Flex, Typography } from '@aloft/toolkit-sui';

import { OrderTag } from '../OrderTable/types.ts';
import { getOrderTagBackgroundColor } from './utils/getOrderTagBackgroundColor.ts';
import { getOrderTagTextColor } from './utils/getOrderTagTextColor.ts';

export const OrderCardTags = ({ tags, orderID }: { tags: OrderTag[]; orderID: string }) => (
  <Flex gap={2}>
    {tags.map((tag) => (
      <Block
        key={`${orderID}-${tag}`}
        backgroundColor={getOrderTagBackgroundColor(tag)}
        padding="2px 8px"
        height="25px"
        borderRadius="5px"
      >
        <Typography
          variant="body1"
          __dangerDoNotUseSx={{ fontWeight: 600 }}
          color={getOrderTagTextColor(tag)}
        >
          {tag}
        </Typography>
      </Block>
    ))}
  </Flex>
);
